import Utils from '@/utils';

import './styles/ChatTimestamp.css';

export default function ChatTimestamp({ timestamp }) {
  return (
    <>
      <span className="chat-timestamp__container font-size-medium">
        {Utils.getChatTimestamp(timestamp)}
      </span>
    </>
  );
}
